import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { Box, Stack, Typography } from "@mui/material";
import type { DraftOfferCargo } from "../model";

export const VehicleInfo = (
  props: Pick<DraftOfferCargo, "vehicleEquipmentMemo" | "memo">,
) => {
  return (
    <Stack spacing={1} maxWidth="628px">
      <Typography
        variant="body1"
        fontWeight={700}
        mb={1}
        sx={{
          "::before": {
            content: '"■"',
            fontSize: "150%",
            marginRight: "2px",
          },
        }}
      >
        車両条件・その他
      </Typography>
      <Box>
        <BaseKeyValue keyLabel="装備品">
          <Typography
            variant="body2"
            color={props.vehicleEquipmentMemo ? "grey.900" : "grey.500"}
          >
            {props.vehicleEquipmentMemo ?? "未記入"}
          </Typography>
        </BaseKeyValue>
        <BaseKeyValue keyLabel="その他・特記事項">
          <Typography
            variant="body2"
            color={props.memo ? "grey.900" : "grey.500"}
          >
            {props.memo ?? "未記入"}
          </Typography>
        </BaseKeyValue>
      </Box>
    </Stack>
  );
};
